<template>
  <div class="event-trainer row">
    <div v-if="showTrainerCompany" class="col-12 mb-3 col-md-6">
      <Field
        type="select"
        name="trainer_company"
        label="Trainer Company *"
        :options="trainerCompanyOptions"
        v-model="trainerCompany"
        :hide-select-empty-option="true"
      />
    </div>
    <div class="col-12 col-md-6">
      <Field
        type="select"
        name="trainer_id"
        label="Trainer *"
        :options="trainerOptions"
        :value="event.trainer_id"
        :hide-select-empty-option="true"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
    course: { type: Object, required: true },
    trainers: { type: Array, default: () => [] },
  },
  data() {
    return {
      trainerCompany: null,
      trainer: null,
    };
  },
  computed: {
    showTrainerCompany() {
      return (
        !this.course.trainers ||
        this.course.owner_type === this.$root.constants.DISTRIBUTOR_OWNED
      );
    },
    trainerCompanyOptions() {
      var company_ids = [];
      var options = [];
      this.trainers.forEach((t) => {
        if (!!t.company_id && !company_ids.includes(t.company_id)) {
          options.push({ label: t.company_name, value: t.company_id });
          company_ids.push(t.company_id);
        }
      });
      return options.sort((a, b) => {
        return a.label < b.label ? -1 : 1;
      });
    },
    trainerOptions() {
      if (this.showTrainerCompany && !this.trainerCompany) {
        return [
          {
            label: "--- Select a Trainer Company ---",
            value: null,
          },
        ];
      }
      var options = this.trainers.filter((t) => {
        return !this.showTrainerCompany || t.company_id == this.trainerCompany;
      });
      options.unshift({
        label: "--- No Preference ---",
        value: `default_${options[0].value}`,
      });
      return options;
    },
  },
  created() {
      if (this.event.trainer_company_id) {
          this.trainerCompany = this.event.trainer_company_id;
      }
      if (this.event.trainer_id) {
          this.trainer = this.event.trainer_id;
      }
  }
};
</script>